import { render, staticRenderFns } from "./simplifyShopFee.vue?vue&type=template&id=a397d7a4&scoped=true"
import script from "./simplifyShopFee.vue?vue&type=script&lang=js"
export * from "./simplifyShopFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyShopFee.vue?vue&type=style&index=0&id=a397d7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a397d7a4",
  null
  
)

export default component.exports